import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSetPasswordPath = () => {
  return urlHelper('/auth/set-password/');
};
